import { createSlice } from "@reduxjs/toolkit";

export const OrderSlice =createSlice({
    name:"order",
    initialState:{
        OrderList:[],
        singleOrder:{}
    },
    reducers:{
        setOrderList:(state,action)=>{
            state.OrderList = action.payload;
        },
        setSingleOrder:(state,action)=>{
            state.singleOrder = action.payload;
        }
    }
})

export const {setOrderList,setSingleOrder} = OrderSlice.actions;
export default OrderSlice.reducer;